/**
 * @generated SignedSource<<29d69aa9042c55bfbe75db67d6d6f171>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AutoRecordRuleLevel = "GROUP" | "USER" | "WORKSPACE";
import { FragmentRefs } from "relay-runtime";
export type CustomRulesBanner$data = {
  readonly autoRecordRules: ReadonlyArray<{
    readonly ruleLevel: AutoRecordRuleLevel;
  }>;
  readonly " $fragmentType": "CustomRulesBanner";
};
export type CustomRulesBanner$key = {
  readonly " $data"?: CustomRulesBanner$data;
  readonly " $fragmentSpreads": FragmentRefs<"CustomRulesBanner">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CustomRulesBanner",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AutoRecordRule",
      "kind": "LinkedField",
      "name": "autoRecordRules",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ruleLevel",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f15ca136c0385e0f9aed8c0f86ef5b18";

export default node;
